import { Typography, Grid, Paper } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { drawerWidth, ticketBarHeight } from '..';
import { IRREGULARITIES, VEHICLES } from '../../../routes';
import { pixSlice, useDispatch, useSelector } from '../../../stores';
import { palette } from '../../../theme';
import { Button } from '../../Button';

export const PixBar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { ticketTimeLeft, ticketRenovate } = useSelector(
    (state) => state.ticketPurchaseReducer,
  );
  const { hasOpenPix } = useSelector((state) => state.pixReducer);
  const { hasAnyIrregularity } = useSelector(
    (state) => state.irregularitiesReducer,
  );

  const handleManageOpenPix = () => {
    dispatch(pixSlice.actions.toggleManagePixIsOpen());
  };

  const hideIrregularitiesBar =
    location.pathname === IRREGULARITIES ||
    location.pathname.startsWith(`${IRREGULARITIES}/`) ||
    location.pathname === VEHICLES ||
    location.pathname.startsWith(`${VEHICLES}/`);
  const showIrregularitiesBar = hasAnyIrregularity && !hideIrregularitiesBar;

  const hasTicket = ticketTimeLeft > 0 || ticketRenovate;
  const barsAbove = (hasTicket ? 1 : 0) + (showIrregularitiesBar ? 1 : 0);

  return hasOpenPix ? (
    <Grid
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)`, xs: '100%' },
        position: 'absolute',
        top: {
          sm: 64 + barsAbove * ticketBarHeight,
          xs: 56 + barsAbove * ticketBarHeight,
        },
        right: 0,
        borderRadius: 0,
      }}
    >
      <Paper
        sx={{
          backgroundColor: palette.secondary.main,
          borderRadius: 0,
          height: ticketBarHeight,
          boxShadow: `0px 15px 10px 1px rgba(0, 0, 0, 0.3)`,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0 10px 0 10px',
        }}
      >
        <Typography
          color='white'
          sx={{
            fontSize: {
              xs: '12px',
              sm: '14px',
              md: '18px',
            },
          }}
        >
          Você tem um Pix de ticket de rua em aberto
        </Typography>
        <Button
          variant='contained'
          label='Gerenciar'
          onClick={handleManageOpenPix}
          color='primary'
        />
      </Paper>
    </Grid>
  ) : null;
};
